import { render, staticRenderFns } from "./Apiculturas.vue?vue&type=template&id=487596ea"
import script from "./Apiculturas.vue?vue&type=script&lang=js"
export * from "./Apiculturas.vue?vue&type=script&lang=js"
import style0 from "./Apiculturas.vue?vue&type=style&index=0&id=487596ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports